import { useEffect, useMemo } from "react";

interface ConfettiProps {
  onComplete: () => void;
}

const PARTICLE_COUNT = 20;

interface Particle {
  left: string;
  size: number;
  delay: string;
  duration: string;
  color: string;
}

const COLORS = [
  "hsl(45, 100%, 51%)",  // gold
  "hsl(45, 100%, 60%)",  // light gold
  "hsl(45, 100%, 40%)",  // dark gold
  "hsl(35, 100%, 55%)",  // orange-gold
  "hsl(55, 100%, 55%)",  // yellow-gold
];

export const Confetti = ({ onComplete }: ConfettiProps) => {
  const particles = useMemo<Particle[]>(() => {
    return Array.from({ length: PARTICLE_COUNT }, () => ({
      left: `${Math.random() * 100}%`,
      size: 4 + Math.random() * 8,
      delay: `${Math.random() * 0.8}s`,
      duration: `${1.2 + Math.random() * 1}s`,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
    }));
  }, []);

  useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 pointer-events-none z-[100]">
      {particles.map((p, i) => (
        <div
          key={i}
          className="absolute rounded-sm"
          style={{
            left: p.left,
            width: p.size,
            height: p.size,
            backgroundColor: p.color,
            animation: `confettiFall ${p.duration} ease-in ${p.delay} forwards`,
          }}
        />
      ))}
    </div>
  );
};
